export const urlToSend = (title: string) => {
    let categoryTitle = title;
    switch (title) {
        case 'asian antiques':
            categoryTitle = 'asian';
            break;

        case 'home & décor':
            categoryTitle = 'home-and-decor';
            break;

        case 'coins':
            categoryTitle = 'coins-currency-and-stamps';
            break;

        default:
            title;
    }
    return categoryTitle;
};
